export default '0.14.7';



// WEBPACK FOOTER //
// ./version.js